const Isotope = require('isotope-layout');
const team = document.querySelector('.team');
const filterBtns = document.querySelectorAll('.filterButton');
const filtersElem = document.querySelector('.filterButtonGroup');
const filterMessage = document.querySelector('#filterMessage');

if (team) {

	window.addEventListener('load', () => {
		let iso = new Isotope(team, {
			// options
			itemSelector: '.teamItem',
			layoutMode: 'fitRows',
			filter: '.the-board',
			// sort board members first, then by data-sort-order
			getSortData: {
				board: '[data-board]',
				sortOrder: '[data-sort-order] parseInt',
			},
			sortBy: ['board', 'sortOrder'],
			sortAscending: {
				board: false,
				sortOrder: true
			},
		});

		if (filtersElem) {
			// bind filter button click
			filtersElem.addEventListener('click', ( e ) => {
				let filterValue = e.target.getAttribute('data-filter');

				iso.arrange({
					filter: filterValue,
					sortBy: ['board', 'sortOrder'],
					sortAscending: {
						board: false,
						sortOrder: true
					},
				});
			});
		}

		filterBtns.forEach( (item) => {
			item.addEventListener('click', () => {

				filterBtns.forEach( (item) => {
					item.classList.remove('is-active');
				})

				item.classList.add('is-active');
			});
		})
	});
}
